<template>
  <div class="direct-message-queues-targets">
    <div class="mb-x2" layout layout-align="space-between-start">
      <el-button type="default" @click="backToQueueList"
        ><i class="mdi mdi-keyboard-backspace"></i>一覧に戻る</el-button
      >
      <csv-download :disabled="!messages.length || is_download" :download="downloadCsv"></csv-download>
    </div>
    <el-table
      class="mb-x2"
      v-loading="loading"
      :data="messages"
      stripe
      empty-text="データがありません。"
      style="width: 100%"
    >
      <el-table-column label="ステータス" min-width="30%">
        <template slot-scope="scope">
          <div class="text-info" v-if="messageQueueStatus === 'scheduled'">スケジュール済み</div>
          <div class="text-disabled" v-if="messageQueueStatus === 'draft'">下書き</div>
        </template>
      </el-table-column>
      <el-table-column label="宛先アカウント" min-width="70%">
        <template slot-scope="scope">
          <applicant-name :applicant="scope.row"></applicant-name>
        </template>
      </el-table-column>
    </el-table>
    <pagination v-if="messages.length" :total="total"></pagination>
  </div>
</template>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import moment from 'moment'
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import ApplicantName from '@/client/components/_atoms/applicant_name'
import CsvDownload from '@/client/components/_atoms/csv_download'
import Pagination from '@/client/components/_atoms/pagination'
import api from '@/client/core/api'
import { useTwitterDirectMessageDialogStore } from '@/client/store/useTwitterDirectMessageDialogStore'

export default defineComponent({
  props: {
    messageQueueId: Number,
    messageQueueStatus: String,
    backToMessageQueuesList: Function
  },
  components: {
    ApplicantName,
    CsvDownload,
    Pagination
  },
  data() {
    return {
      messages: [],
      loading: false,
      is_download: false,
      total: 0
    }
  },
  created() {
    // メッセージ一覧を取得
    this.getMessages()
  },
  computed: {
    ...mapState(useTwitterDirectMessageDialogStore, ['campaignId', 'prizeId'])
  },
  methods: {
    ...mapActions(useTwitterDirectMessageDialogStore, ['fetchQueueList', 'setQueueListIsShowDetail']),

    /**
     * メッセージ一覧を取得
     */
    async getMessages() {
      if (!this.messageQueueId) {
        return
      }

      this.loading = true
      const params = { campaignId: this.campaignId, prizeId: this.prizeId }
      const result = await api.get(`/twitter_message_queues/targets/${this.messageQueueId}`, {
        params
      })
      this.loading = false

      if (!result.data) {
        this.messages = []
        this.total = 0
        return
      }

      this.messages = result.data
      this.total = result.data.length
    },

    /**
     * メッセージキューに戻る
     */
    backToQueueList() {
      this.fetchQueueList()
      this.setQueueListIsShowDetail(false)
      this.backToMessageQueuesList()
    },

    /**
     * CSVダウンロード
     */
    async downloadCsv() {
      this.is_download = true

      const params = { campaignId: this.campaignId, prizeId: this.prizeId }
      const result = await api.get(`/twitter_message_queues/targets/${this.messageQueueId}`, {
        params
      })

      this.is_download = false

      if (!result.data) {
        this.$notify({
          title: 'CSVダウンロードに失敗しました。',
          message: '恐れ入りますが、時間をおいて再度お試しください。',
          customClass: 'danger',
          duration: 5000
        })
        return
      }

      const messages = result.data
      const filename = `campaign_messages_targets_${moment().format('YYYY_MM_DD')}`
      const csvData = []
      csvData.push(['ステータス', 'アカウント名', 'アカウントスクリーンネーム', 'アカウント画像'])

      const status = this.messageQueueStatus === 'scheduled' ? 'スケジュール済み' : '下書き'

      // CSVデータを格納
      messages.forEach(message => {
        csvData.push([status, message.name, message.screenName, message.pictureUrl])
      })

      return {
        filename,
        data: csvData
      }
    }
  }
})
</script>
